module.exports = "<p>{{message}}</p>\r\n\r\n<hr>\r\n\r\n<button (click)=\"closeDialog('load')\">Load File</button>\r\n<button (click)=\"closeDialog('new')\">New File</button>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/ui-components/dialogs/file-load-dialog.html
// module id = ../../../../../src/app/ui-components/dialogs/file-load-dialog.html
// module chunks = main